const gSelector = {
    btn: {
        edit: '.js_action_edit',
        delete: '.js_action_delete',
        modal: {
            save: '.js_btn_modal_save',
            confirm: '.js_btn_modal_confirm'
        },
        filter: {
            reset: '#btn_filter_reset',
        },
    },
    modal: {
        delete: '#modal_delete',
        deleteBs: '#modal_delete_bs',
        errors: {
            general: '.js_modal_general_error'
        },
        success: {
            general: '.js_modal_general_success'
        }
    }
}

export { gSelector };